<template>
  <div
    v-if="internalValue && internalProfileValue"
    id="applicant-edit-tab-personal-data"
    class="applicant-show-form"
  >
    <div class="vx-row">
      <div class="vx-col w-full">
        <ValidationObserver ref="InternalData" tag="form">
          <InternalData
            v-model="internalValue"
            :profile="internalProfileValue"
            @profileInput="v => (internalProfileValue = v)"
          />
        </ValidationObserver>
        <div style="text-align:right;">
          <vs-button class="my-3" @click="saveAllImmediate()"
            >Speichern</vs-button
          >
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import gql from "graphql-tag";
import InternalData from "../form/InternalData";
import editFormMixin from "@/mixins/editFormMixin.js";

export default {
  components: {
    InternalData
  },
  mixins: [
    editFormMixin({
      methodSuffix: "Applicant",
      idFields: ["entryType", "group"],
      ignoredFields: ["user", "privacyPolicyRequestedDate"],
      legacyIDFields: ["source"]
    }),
    editFormMixin({
      dataProp: "internalProfileValue",
      methodSuffix: "Profile",
      idFields: ["skillJobType", "internalConsultant", "state"]
    })
  ],
  props: {
    profileId: {
      type: String,
      default() {
        return null;
      }
    }
  },
  apollo: {
    applicant: {
      query: gql`
        query Applicant($id: ID!) {
          applicant(id: $id) {
            id
            wantsNewsletter
            privacyPolicyAccepted
            privacyPolicyRequestedDate
            l1sync
            group {
              id
              name
            }
            source {
              id
              name
            }
            entryType {
              id
              name
            }
          }
        }
      `,
      result() {
        this.updateCurrentApplicant();
      },
      variables() {
        return {
          id: this.$route.params.id
        };
      }
    },
    applicantProfile: {
      query: gql`
        query ApplicantProfile($id: ID!) {
          applicantProfile(id: $id) {
            id
            internalRatingComment
            rating
            active
            state {
              id
              name
            }
            internalConsultant {
              id
              firstName
              lastName
            }
            skillJobType {
              id
              name
            }
          }
        }
      `,
      result() {
        this.updateCurrentProfile();
      },
      variables() {
        return {
          id: this.profileId
        };
      }
    }
  },
  computed: {
    internalValue: {
      get() {
        return this.applicant;
      },
      set(v) { // eslint-disable-line
        this.saveApplicant(false);
      }
    },
    internalProfileValue: {
      get() {
        return this.applicantProfile;
      },
      set(v) { // eslint-disable-line
        this.saveProfile(false);
      }
    }
  },
  methods: {
    async saveAllImmediate() {
      this.saveApplicant();
      this.saveProfile();
    },
    async persistApplicant() {
      let result = await this.$refs.InternalData.validate();
      if (result == true) {
        try {
          let input = this.getInputApplicant();
          await this.$apollo.mutate({
            mutation: gql`
              mutation($id: ID!, $input: ApplicantInput!) {
                updateApplicant(id: $id, input: $input) {
                  id
                }
              }
            `,
            variables: {
              id: this.$route.params.id,
              input
            }
          });

          this.reportSuccessApplicant(input);
        } catch (e) {
          this.reportUnhandledErrorApplicant(error); // eslint-disable-line
        }
      } else {
        this.$vs.notify({
          title: "Speichern fehlgeschlagen",
          text: "Bitte überprüfe ob alle Pflichtfelder eingetragen sind.",
          color: "danger",
          icon: "query_builder",
          position: "bottom-center",
          time: 5000
        });
      }
    },
    async persistProfile() {
      let result = await this.$refs.InternalData.validate();
      if (result == true) {
        try {
          let input = this.getInputProfile();
          await this.$apollo.mutate({
            mutation: gql`
              mutation($id: ID!, $input: ApplicantProfileInput!) {
                updateApplicantProfile(id: $id, input: $input) {
                  id
                }
              }
            `,
            variables: {
              id: this.profileId,
              input
            }
          });

          this.reportSuccessProfile(input);
        } catch (e) {
          this.reportUnhandledErrorProfile(error); // eslint-disable-line
        }
      } else {
        this.$vs.notify({
          title: "Speichern fehlgeschlagen",
          text: "Bitte überprüfe ob alle Pflichtfelder eingetragen sind.",
          color: "danger",
          icon: "query_builder",
          position: "bottom-center",
          time: 5000
        });
      }
    }
  }
};
</script>
